import React from 'react';
import CandidateLinkFieldWithName from 'domain/recruiting/newVacancy/shared/fields/CandidateLinkFieldWithName';
import { FieldProps } from 'framework/ui/field';
import { Checkbox, useInputHelper } from 'framework/form';
import { useShowContext } from 'framework/show';
import { Tooltip } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

const CandidateLinkFieldWithNameWithCheckbox = (props: FieldProps) => {
  const { data } = useShowContext();
  const { getValue, getRawOnChangeCallback } = useInputHelper<string[]>({ source: 'actualDuplicateIds' });
  const rowData = data.getData();
  const value = getValue() as string[];
  const parentOnChange = getRawOnChangeCallback()!;

  const onChangeCallback = () => {
    if (value.includes(rowData.id)) {
      parentOnChange({
        actualDuplicateIds: value.filter(item => item !== rowData.id),
      });
    } else {
      parentOnChange({
        actualDuplicateIds: [...value, rowData.id],
      });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        span: {
          flex: '0 0 85%',
        },
      }}
    >
      <CandidateLinkFieldWithName {...props} />
      <Tooltip placement="top" title="Duplicate">
        <Box>
          <Checkbox
            value={value.includes(rowData.id)}
            onChangeCallback={onChangeCallback}
            label=""
            source="test"
            sx={{
              marginBottom: '0 !important',
              '& .MuiFormControlLabel-root': {
                marginRight: 0,
                marginLeft: 0,
                '& .MuiCheckbox-root': {
                  padding: 0,
                  justifyContent: 'flex-end',
                },
              },
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

export default CandidateLinkFieldWithNameWithCheckbox;
